import { makeStyles } from 'tss-react/mui';
import HostField from '../forms/host-field';

const useStyles = makeStyles()((theme) => ({
  field: {
    marginBottom: theme.spacing(2),
  },
}));

type Props = {
  disabled: boolean;
  forceTouched: boolean;
  [key: string]: unknown;
};

const EventFormHost = ({ disabled, forceTouched, ...rest }: Props) => {
  const { classes } = useStyles();

  return (
    <HostField
      name="hostType"
      label="Host"
      disabled={disabled}
      touched={forceTouched}
      className={classes.field}
      {...rest}
    />
  );
};

export default EventFormHost;
